<template>
    <painel titulo="" :mostrarRefresh="false">
        <div class="formgrid grid col-12 border-solid border-1 surface-border border-round-md m-2 pr-2 pl-2 pt-4">
            <h3 class="field col-12 md:col-12">Cadastro produto</h3>
            <div class="field col-12 md:col-3">
                <div class="flex flex-column">
                    <label class="mb-2">Natureza: *</label>
                    <Dropdown
                        id="natureza"
                        optionLabel="descricao"
                        v-model="naturezaSelecionada"
                        filter
                        optionValue="codigo"
                        :options="naturezas"
                        @blur="v$.naturezaSelecionada.$touch()"
                    ></Dropdown>
                    <small class="p-error mt-2" v-if="v$.naturezaSelecionada.$error">Campo obrigatório</small>
                </div>
            </div>
            <div class="field col-12 md:col-6">
                <div class="flex flex-column">
                    <label class="mb-2">Projetos: *</label>
                    <Dropdown
                        class="produtos"
                        id="produto"
                        optionLabel="descricaoDetalhe"
                        v-model="produtoSelecionado"
                        filter
                        editable
                        :options="produtos"
                        optionvalue="produtoId"
                        @blur="v$.produtoSelecionado.$touch(), aplicaStyles()"
                    ></Dropdown>
                    <!-- <Input @novo-produto="novoProduto" /> -->
                    <small class="p-error mt-2" v-if="v$.produtoSelecionado.$error">{{
                        v$.produtoSelecionado.$silentErrors[0]?.$message || 'Produto selecionado é obrigatório'
                    }}</small>
                </div>
            </div>
            <div class="field col-12 md:col-3">
                <div class="flex flex-column">
                    <label class="mb-2">Valor: *</label>
                    <InputNumber
                        :disabled="!naturezaSelecionada"
                        v-model="valor"
                        inputId="currency-br"
                        mode="currency"
                        currency="BRL"
                        locale="pt-BR"
                        @input="oninput($event)"
                    />
                    <small class="p-error mt-1" v-if="v$.valor.$error">Campo obrigatório</small>
                </div>
            </div>
            <div class="field col-12">
                <div class="flex flex-column">
                    <label class="mb-2">Descrição:</label>
                    <Textarea :disabled="!naturezaSelecionada" v-model="descricao" rows="5" cols="30" autoResize maxlength="1000" />
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <div class="flex flex-column">
                    <label class="mb-2">Unidade Operacional: *</label>
                    <Dropdown
                        @blur="v$.unidOperacSelecionada.$touch()"
                        @click="onClickObterProjetos"
                        :disabled="!naturezaSelecionada"
                        optionLabel="nome"
                        v-model="unidOperacSelecionada"
                        filter
                        :options="unidadesOperacionais"
                        optionValue="codUnidade"
                    ></Dropdown>
                    <small class="p-error mt-1" v-if="v$.unidOperacSelecionada.$error">Campo obrigatório</small>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <div class="flex flex-column">
                    <label class="mb-2">Projeto: *</label>
                    <Dropdown
                        :disabled="!unidOperacSelecionada"
                        optionLabel="nome"
                        v-model="projetoSelecionado"
                        filter
                        :options="projetos"
                        optionValue="codProjeto"
                        @blur="v$.projetoSelecionado.$touch(), aplicaStyles()"
                    ></Dropdown>
                    <small class="p-error mt-1" v-if="v$.projetoSelecionado.$error">Campo obrigatório</small>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <div class="flex flex-column">
                    <label class="mb-2">Ação: *</label>
                    <Dropdown
                        :disabled="desabilitarAcao"
                        @blur="v$.acaoSelecionada.$touch()"
                        optionLabel="nome"
                        v-model="acaoSelecionada"
                        filter
                        :options="acoes"
                        optionValue="codAcao"
                    ></Dropdown>
                    <small class="p-error mt-1" v-if="v$.acaoSelecionada.$error">Campo obrigatório</small>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <div class="flex flex-column">
                    <label class="mb-2">Data início: *</label>
                    <Calendar
                        :disabled="!naturezaSelecionada"
                        v-model="dataInicial"
                        placeholder="dd/mm/aaaa"
                        :monthNavigator="true"
                        :yearNavigator="true"
                        showIcon
                        :manualInput="true"
                        @date-select="v$.dataInicial.$touch()"
                    />
                    <small class="p-error flex flex-column" v-if="v$.dataInicial.$error">
                        <span v-if="v$.dataInicial.required.$invalid">Campo obrigatório</span>
                        <span class="mt-1" v-if="v$.dataInicial.dataMenorQueFinal.$invalid">{{ v$.dataInicial.dataMenorQueFinal.$message }}</span>
                    </small>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <div class="flex flex-column">
                    <label class="mb-2">Data fim: *</label>
                    <Calendar
                        :disabled="!naturezaSelecionada"
                        v-model="dataFinal"
                        placeholder="dd/mm/aaaa"
                        :monthNavigator="true"
                        :yearNavigator="true"
                        showIcon
                        :manualInput="true"
                        @date-select="v$.dataFinal.$touch()"
                    />
                    <small class="p-error flex flex-column" v-if="v$.dataFinal.$error">
                        <span v-if="v$.dataInicial.required.$invalid">Campo obrigatório</span>
                        <span class="mt-1" v-if="v$.dataFinal.dataMaiorQueInicial.$invalid">{{ v$.dataFinal.dataMaiorQueInicial.$message }}</span>
                    </small>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <div class="flex flex-column">
                    <label class="mb-2">Código do evento/contrato</label>
                    <InputText :disabled="!naturezaSelecionada" type="text" v-model="codEventoContrato" maxLength="100" />
                </div>
            </div>
            <div class="field col-12 md:col-12">
                <label class="mb-2 mt-2">* Campos obrigatórios</label>
            </div>
        </div>

        <div class="field col-12 md:col-12">
            <div class="flex flex-column">
                <div class="flex align-items-center mb-2">
                    <label class="mb-2">CPF/CNPJ: *</label>
                </div>
                <div class="flex">
                    <InputText
                        :disabled="desabilitarDocumento"
                        :placeholder="docPlaceholder"
                        :value="documentoFormatado"
                        @input="formatarDocumento"
                        maxLength="18"
                        class="mr-3"
                        @blur="v$.documento.$touch()"
                    />
                    <Button :disabled="botaoDocumentoDesabilitado" icon="pi pi-plus" @click="verificarDocumento" />
                </div>
                <!-- <small class="p-error mt-2" v-if="v$.documento.$invalid && v$.documento.$error"> Documento inválido </small> -->
            </div>
            <div v-for="(cpf, index) in checkouts" :key="index">
                <CardCpfRM @atualizar-email="atualizarEmail" :cpfRM="cpf" />
            </div>
            <div class="flex mt-4 g-2">
                <Button :disabled="checkouts.length === 0 || !checkouts[0]?.email" class="mr-4" label="Publicar" icon="pi pi-upload" @click="publicar" />
                <Button label="Limpar" icon="pi pi-times" class="p-button-text" @click="limparCampos" />
            </div>
        </div>
    </painel>
    <Dialog v-model:visible="showDialogClientForm" @hide="showDialogClientForm = false" :style="{ width: '80vw' }">
        <ClienteForm :cpfCnpjProp="cpfCnpj" @clienteCadastrado="clienteCadastrado()" />
    </Dialog>
</template>

<script>
import service from './service';
import { helpers, required, maxLength } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import CardCpfRM from './CardCpfRM.vue';
import ClienteForm from '../cadastroclientes/ClienteForm.vue';

export default {
    name: 'GerarLinkProdutoForm',
    components: {
        CardCpfRM,
        ClienteForm,
    },
    setup: () => ({ v$: useVuelidate({ $stopPropagation: true, $scope: 'CheckoutVendaForm' }) }),

    emits: ['publicar'],

    props: {
        dadosVenda: {
            type: Object,
        },
    },

    data() {
        return {
            titulo: null,
            naturezas: [],
            produtos: [],
            projetos: [],
            acoes: [],
            unidadesOperacionais: [],
            naturezaSelecionada: null,
            produtoSelecionado: null,
            projetoSelecionado: null,
            acaoSelecionada: null,
            unidOperacSelecionada: null,
            valor: null,
            descricao: null,
            dataInicial: new Date(),
            dataFinal: new Date(),
            codEventoContrato: null,
            cpfCnpj: null,
            checkouts: [],
            mostrarModalProduto: false,
            inserirNoZero: false,
            valorFilter: null,
            showDialogClientForm: false,
            error: null,
            tipoDocumento: 'CPF',
            documento: null,
        };
    },
    validations() {
        return {
            naturezaSelecionada: { required },
            produtoSelecionado: {
                required: helpers.withMessage('O produto é obrigatório', required),
                maxLength: helpers.withMessage('O título do produto deve ter no máximo 200 caracteres', maxLength(200)),
            },
            valor: { required },
            projetoSelecionado: { required },
            acaoSelecionada: { required },
            unidOperacSelecionada: { required },
            dataInicial: {
                required,
                dataMenorQueFinal: helpers.withMessage('Não pode ser maior que a data final.', (val) => {
                    const dataInicial = this.$moment(val, 'DD/MM/YYYY');
                    const dataFinal = this.$moment(this.dataFinal, 'DD/MM/YYYY');
                    if (!dataFinal.isValid()) return true;
                    return dataInicial.isSameOrBefore(dataFinal);
                }),
            },
            dataFinal: {
                required,
                dataMaiorQueInicial: helpers.withMessage('Não pode ser menor que a data de início.', (val) => {
                    const dataFinal = this.$moment(val, 'DD/MM/YYYY');
                    const dataInicial = this.$moment(this.dataInicial, 'DD/MM/YYYY');
                    return dataFinal.isSameOrAfter(dataInicial);
                }),
            },
            documento: {
                required,
                documentoValido: () => {
                    const digitos = this.documento.replace(/\D/g, '');
                    return digitos.length === 11 ? this.$validarCPF(digitos) : digitos.length === 14 ? this.$validarCNPJ(digitos) : false;
                },
            },
        };
    },
    mounted() {
        this.obterNaturezas();
        this.obterUnidadesOperacionais();
        this.obterProdutos();
    },
    computed: {
        desabilitarAcao() {
            return !(this.naturezaSelecionada && this.projetoSelecionado && this.unidOperacSelecionada);
        },
        desabilitarDocumento() {
            return !(
                this.unidOperacSelecionada &&
                this.naturezaSelecionada &&
                this.projetoSelecionado &&
                this.acaoSelecionada &&
                this.produtoSelecionado &&
                this.valor
            );
        },
        botaoDocumentoDesabilitado() {
            if (!this.documento) return true;
            const len = this.documento.length;
            return len !== 11 && len !== 14;
        },
        docPlaceholder() {
            if (!this.documento || this.documento.length < 12) {
                return '000.000.000-00';
            }
            return '00.000.000/0000-00';
        },
        documentoFormatado() {
            if (!this.documento) return '';
            const digitsOnly = this.documento;

            if (digitsOnly.length <= 11) {
                return digitsOnly
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
            } else {
                return digitsOnly
                    .slice(0, 14)
                    .replace(/(\d{2})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1/$2')
                    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
            }
        },
    },
    watch: {
        projetoSelecionado() {
            if (this.projetoSelecionado && this.unidOperacSelecionada) this.obterAcoes();
        },
        unidOperacSelecionada() {
            if (this.unidOperacSelecionada) this.obterProjetosPorUnidade(this.unidOperacSelecionada);
        },
        produtoSelecionado() {
            if (this.produtoSelecionado?.produtoId) this.preencherCampos(this.produtoSelecionado);
        },
        tipoDocumento() {
            this.documento = null;
            this.v$.documento.$reset();
        },
    },
    methods: {
        oninput(event) {
            if (!event.value) {
                this.v$.valor.$touch();
                return;
            }
            this.v$.valor.$reset();
        },

        formatarDocumento(event) {
            this.documento = event.target.value.replace(/\D/g, '');
        },

        obterNaturezas() {
            this.$store.dispatch('addRequest');
            service
                .obterNaturezas()
                .then((response) => {
                    this.naturezas = response.data;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'Natureza', detail: 'Erro ao obter Naturezas', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        obterProjetos() {
            this.$store.dispatch('addRequest');
            service
                .obterProjetos(this.unidOperacSelecionada)
                .then((response) => {
                    this.projetos = response.data;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'Projetos', detail: 'Erro ao obter Projetos', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },
        obterProjetosPorUnidade(id) {
            this.$store.dispatch('addRequest');
            service
                .obterProjetosPorUnidade(id)
                .then((response) => {
                    this.projetos = response.data;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'Projetos', detail: 'Erro ao obter Projetos', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        obterAcoes() {
            this.$store.dispatch('addRequest');
            service
                .obterAcoes(this.projetoSelecionado, this.unidOperacSelecionada)
                .then((response) => {
                    this.acoes = response.data;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'Ações', detail: 'Erro ao obter Ações', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        obterUnidadesOperacionais() {
            this.$store.dispatch('addRequest');
            service
                .obterUnidadesOperacionais()
                .then((response) => {
                    this.unidadesOperacionais = response.data;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'Unidades Operacionais', detail: 'Erro ao obter Unidades Operacionais', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        obterProdutos() {
            this.$store.dispatch('addRequest');
            service
                .obterProdutos()
                .then((response) => {
                    this.produtos = response.data;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'Produtos', detail: 'Erro ao obter Produtos', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        clienteCadastrado() {
            this.showDialogClientForm = false;
            this.verificarCpf(this.cpfCnpj);
        },

        verificarCpf(cpf) {
            this.$store.dispatch('addRequest');
            service
                .verificarCpf(cpf)
                .then((response) => {
                    if (!response.data) {
                        this.$store.dispatch('removeRequest');
                        this.$confirm.require({
                            message: 'CPF/CNPJ não localizado, deseja realizar o cadastro?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            accept: () => {
                                this.cpfCnpj = this.documento;
                                this.showDialogClientForm = true;
                            },
                        });
                        return;
                    }
                    this.checkouts.push(response.data);
                    this.cpfCnpj = null;
                    this.documento = null;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'CPF/CNPJ', detail: 'Erro ao verificar CPF/CNPJ no RM', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        verificarDocumento() {
            return this.verificarCpf(this.documento);
        },

        limparCampos() {
            this.naturezaSelecionada = null;
            this.produtoSelecionado = null;
            this.valor = null;
            this.descricao = null;
            this.projetoSelecionado = null;
            this.acaoSelecionada = null;
            this.unidOperacSelecionada = null;
            this.dataInicial = null;
            this.dataFinal = null;
            this.codEventoContrato = null;
            this.cpfCnpj = null;
            this.checkouts = [];
            this.documento = null;
            this.tipoDocumento = 'CPF';
            this.v$.$reset();
        },

        replacecheckouts(checkouts) {
            return checkouts.map((checkouts) => {
                return {
                    ...checkouts,
                    cpf: checkouts.cpf.replace(/\./g, '').replace('-', ''),
                };
            });
        },

        publicar() {
            let checkouts = this.replacecheckouts(this.checkouts);
            let dados = {
                produtoId: this.produtoSelecionado.produtoId ? this.produtoSelecionado.produtoId : null,
                titulo: this.produtoSelecionado?.titulo ? this.produtoSelecionado?.titulo : this.produtoSelecionado,
                descricao: this.descricao,
                valor: this.valor,
                dataInicial: this.$moment(this.dataInicial).format('YYYY-MM-DDTHH:mm:ss'),
                dataFinal: this.$moment(this.dataFinal).format('YYYY-MM-DDTHH:mm:ss'),
                codigoEvento: this.codEventoContrato,
                unidadeOperacionalId: this.unidOperacSelecionada,
                naturezaId: this.naturezaSelecionada,
                projetoId: this.projetoSelecionado,
                acaoId: this.acaoSelecionada,
                produtoCheckouts: checkouts,
                naturezaDescricao: this.naturezas.find((x) => x.codigo === this.naturezaSelecionada).descricao,
                projetoNome: this.projetos.find((x) => x.codProjeto === this.projetoSelecionado).nome,
                acaoNome: this.acoes.find((x) => x.codAcao === this.acaoSelecionada).nome,
                unidadeOperacionalNome: this.unidadesOperacionais.find((x) => x.codUnidade === this.unidOperacSelecionada).nome,
            };
            this.$emit('publicar', dados);
        },

        atualizarEmail(cliente) {
            this.checkouts.forEach((cpf) => {
                if (cpf.cpf == cliente.cpfCnpj) {
                    cpf.email = cliente.email;
                }
            });
        },

        preencherCampos(produto) {
            this.naturezaSelecionada = produto.naturezaId;
            this.produtoSelecionado = produto;
            this.valor = produto.valor;
            this.descricao = produto.descricao;
            this.projetoSelecionado = produto.codProjeto;
            this.unidOperacSelecionada = produto.codUnidade;
            this.acaoSelecionada = produto.codAcao;
            this.dataInicial = produto.dataInicial ? this.$moment(produto.dataInicial, 'YYYY-MM-DD').toDate() : new Date();
            this.dataFinal = produto.dataFinal ? this.$moment(produto.dataFinal, 'YYYY-MM-DD').toDate() : new Date();
            this.codEventoContrato = produto.codigoEvento;
        },

        aplicaStyles() {
            const dropdownPanel = document.querySelector('.p-dropdown-panel');
            if (dropdownPanel) {
                dropdownPanel.style.minWidth = '94%';
                dropdownPanel.style.maxWidth = '94%';
                dropdownPanel.style.margin = '0 auto';

                const dropdownItems = dropdownPanel.querySelectorAll('.p-dropdown-item');
                dropdownItems.forEach((item) => {
                    item.style.overflow = 'visible';
                });
            }
        },
    },
};
</script>
